import { render } from "./FormVector3D.vue?vue&type=template&id=d6489090&scoped=true&ts=true"
import script from "./FormVector3D.vue?vue&type=script&lang=ts"
export * from "./FormVector3D.vue?vue&type=script&lang=ts"

import "./FormVector3D.vue?vue&type=style&index=0&id=d6489090&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6489090"]])

export default __exports__